module.exports = __webpack_public_path__ + "static/media/user-config-blue.215c4a26.svg";